import React from 'react';
import styles from './OutofRefillsNotification.css';

const OutofRefillsNotification = () => (
  <div className={styles.container}>
    <p className={styles.refillsOut}>
      It looks like your prescription requires a renewal. Don&apos;t worry! Go
      ahead and <strong>place your order</strong> and we will contact your
      veterinarian for approval.
    </p>
    <p className={styles.decline}>
      If for some reason they decline your prescription, we&apos;ll contact you.
    </p>
  </div>
);

export default OutofRefillsNotification;



// WEBPACK FOOTER //
// ./src/containers/CartPage/OutofRefillsNotification.jsx